module.exports = "./assets/images/avatar-8.svg";